// Define the outline filter
fabric.Image.filters.OutlineFilter = fabric.util.createClass(fabric.Image.filters.BaseFilter, {
    type: 'OutlineFilter',

    initialize: function (options) {
        options = options || {};

        this.outlineWidth = options.outlineWidth || 0;
        this.outlineColor = options.outlineColor || '#000000';
    },
    /**
     * Apply the outline effect to the image data.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray representing pixel data.
     */
    applyTo2d: function (options) {
        const outlineWidth = this.outlineWidth; // thickness scale
        if (outlineWidth > 0) {
            const imageOriginal = options.originalEl;
            const imageData = options.imageData;

            // if the image is not loaded, we can't apply the filter
            if (!imageOriginal || imageData.width <= 1 || imageData.height <= 1 || !this.outlineWidth) {
                return;
            }

            const outlineReduction = 250 //the smaller this number, the thicker the outline
            const diagonal = Math.sqrt(imageData.width * imageData.width + imageData.height * imageData.height);
            const actualOutlineWidth = Math.round((diagonal / outlineReduction) * outlineWidth);

            //the size of this temporary canvas should be the size of the picture + a margin
            //the margin equals to 2 outline widths (one for each side)
            const width = imageData.width + 2 * actualOutlineWidth;
            const height = imageData.height + 2 * actualOutlineWidth;

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const tempCtx = canvas.getContext('2d');

            let image = null;
            {
                // draw the original image on a temporary canvas
                const tempCanvas2 = document.createElement('canvas');
                tempCanvas2.width = imageData.width;
                tempCanvas2.height = imageData.height;
                const tempCtx2 = tempCanvas2.getContext('2d');
                tempCtx2.putImageData(imageData, 0, 0);
                image = tempCanvas2;
            }

            if (!image) {
                return;
            }

            const offsets = [-1, -1, 0, -1, 1, -1, -1, 0, 1, 0, -1, 1, 0, 1, 1, 1]; // offset array
            const x = actualOutlineWidth;
            const y = actualOutlineWidth;

            //we have to reduce the scale of the picture so it fits on the original
            //canvas size along with the outline
            const scaleX = 1 - (2 * actualOutlineWidth) / width;
            const scaleY = 1 - (2 * actualOutlineWidth) / height;
            tempCtx.scale(scaleX, scaleY);

            // draw images at offsets from the array scaled by outlineWidth
            for (let i = 0; i < offsets.length; i += 2) {
                tempCtx.drawImage(image, x + offsets[i] * actualOutlineWidth, y + offsets[i + 1] * actualOutlineWidth);
            }

            // fill with color
            tempCtx.globalCompositeOperation = 'source-in';
            tempCtx.fillStyle = this.outlineColor;
            tempCtx.fillRect(0, 0, width, height);

            // draw original image in normal mode
            tempCtx.globalCompositeOperation = 'source-over';
            tempCtx.drawImage(image, x, y);

            //we return the original canvas dimensions
            const transformedImageData = tempCtx.getImageData(
                0,
                0,
                width - 2 * actualOutlineWidth,
                height - 2 * actualOutlineWidth
            );
            imageData.data.set(transformedImageData.data);
        }
    }
});

// Register and apply the filter
fabric.Image.filters.OutlineFilter.fromObject = function () {
    return new fabric.Image.filters.OutlineFilter();
};
